import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/column/task/styles.scss';export default {
  "task": "_task_1oae1_1",
  "header": "_header_1oae1_12",
  "name": "_name_1oae1_18",
  "description": "_description_1oae1_22",
  "descriptionText": "_descriptionText_1oae1_26",
  "hierarchy": "_hierarchy_1oae1_30",
  "tagList": "_tagList_1oae1_34"
};